import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { isInitialised, ConfigurableProperty } from '../configurableProperties';

/**
 * Raw configurableProperties store data
 */
const rawConfigurableProperties = (state: RootState) => state.configurableProperties;

/** Return configurableProperties if they have been initialised, if not returns null
 */
export const configurableProperties = createSelector(rawConfigurableProperties, props => {
    return (props.properties?.filter(cp => isInitialised(cp)) as ConfigurableProperty[]) ?? null;
});

export const propertiesFromLayout = createSelector(
    rawConfigurableProperties,
    props => props.propertiesFromLayout,
);

export type CurrentPropertySelections = {
    propertyKey: string;
    finish: {
        name: string;
    } & {
        colour?: string | undefined;
        image?: string | undefined;
    };
}[];

/** Return just the current property selections, presumably for serialising to a layout
 */
export const currentPropertySelections = createSelector(
    configurableProperties,
    props =>
        props?.map(p => ({
            propertyKey: p.propertyKey,
            finish: p.current,
        })) ?? null,
);

export const setContainsConfigurableProperties = createSelector(
    configurableProperties,
    props => Array.isArray(props) && props.length > 0 && props.every(prop => isInitialised(prop)),
);
